var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "setup-ctn"
  }, [_vm.initialized ? _c('div', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('setup_default_language')) + " ")]), _c('div', {
    staticClass: "font-weight-light py-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('setup_default_language_description1'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('setup_default_language_description2')) + " ")]), _c('v-autocomplete', {
    attrs: {
      "items": _vm.languageDropdown,
      "label": _vm.$t('setup_default_language_label'),
      "item-text": "name",
      "item-value": "key",
      "rules": [function (v) {
        return !!v || _vm.$t('required_field');
      }]
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.$t("languages_".concat(data.item.key))) + " ")];
      }
    }, {
      key: "item",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.$t("languages_".concat(data.item.key))) + " ")];
      }
    }], null, false, 321003644),
    model: {
      value: _vm.selectedDefaultLanguage,
      callback: function callback($$v) {
        _vm.selectedDefaultLanguage = $$v;
      },
      expression: "selectedDefaultLanguage"
    }
  }), _c('div', {
    staticClass: "label font-weight-bold mt-6"
  }, [_vm._v(" " + _vm._s(_vm.$t('translations')) + " ")]), _c('div', {
    staticClass: "font-weight-light py-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('setup_translations_description1'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('setup_translations_description2')) + " ")]), _c('v-autocomplete', {
    staticClass: "my-3",
    attrs: {
      "items": _vm.languageDropdownWithoutDefaultLanguage,
      "search-input": _vm.languageSearchInput,
      "item-text": "name",
      "item-value": "key",
      "chips": "",
      "label": _vm.$t('select_languages'),
      "placeholder": _vm.$t('search_languages'),
      "multiple": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.languageSearchInput = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.languageSearchInput = $event;
      },
      "change": function change($event) {
        _vm.languageSearchInput = '';
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(data) {
        return [_c('v-chip', _vm._b({
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click": data.select,
            "click:close": function clickClose($event) {
              return _vm.removeLanguage(data.item);
            }
          }
        }, 'v-chip', data.attrs, false), [_vm._v(" " + _vm._s(data.item.name) + " ")])];
      }
    }], null, false, 2521109919),
    model: {
      value: _vm.selectedTranslationLanguages,
      callback: function callback($$v) {
        _vm.selectedTranslationLanguages = $$v;
      },
      expression: "selectedTranslationLanguages"
    }
  }), _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedDefaultLanguage,
      "color": "primary",
      "raised": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('continue')))])], 1)], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }